"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_dom_1 = __importDefault(require("react-dom"));
const react_transition_group_1 = require("react-transition-group");
const HelperUtils_1 = require("utils/HelperUtils");
const Tooltip = ({ show, backgroundClassname = 'bg-n-900', className, dataCy, portalData, tooltipId }) => {
    return (react_1.default.createElement(react_transition_group_1.CSSTransition, { in: show, timeout: 300, classNames: "fade", unmountOnExit: true, appear: true },
        react_1.default.createElement("div", { "data-cy": dataCy ? dataCy : 'tooltip-portal', id: tooltipId, className: `${portalData.noWrap ? 'tooltip-portal whitespace-nowrap' : ''} tooltip-avatar pointer-events-none fixed z-9999999 rounded-lg ${backgroundClassname} px-[8px] py-[4px] text-n-000 ${className ? className : ''}`, style: {
                right: portalData.right,
                left: portalData.left,
                top: portalData.top,
                bottom: portalData.bottom,
                transform: `translate(${portalData?.translateX || 0}, ${portalData?.translateY || 0}) `
            } },
            portalData?.tooltipContent || (react_1.default.createElement("p", { className: "typography-h100 break-word whitespace-normal" }, (0, HelperUtils_1.getObjectiveLocale)(portalData.name))),
            portalData.desc && react_1.default.createElement("p", null, (0, HelperUtils_1.getObjectiveLocale)(portalData.desc)))));
};
const TooltipPortal = (props) => {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const sharedTooltip = document.getElementById(props.portalId);
    return react_dom_1.default.createPortal(react_1.default.createElement(Tooltip, { ...props }), sharedTooltip);
};
exports.default = TooltipPortal;
